import { render, staticRenderFns } from "./edit-approval-modal.vue?vue&type=template&id=deedca0c"
import script from "./edit-approval-modal.ts?vue&type=script&lang=ts&external"
export * from "./edit-approval-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./edit-approval-modal.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('deedca0c')) {
      api.createRecord('deedca0c', component.options)
    } else {
      api.reload('deedca0c', component.options)
    }
    module.hot.accept("./edit-approval-modal.vue?vue&type=template&id=deedca0c", function () {
      api.rerender('deedca0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/view-in-year-budget-request/edit-approval-modal/edit-approval-modal.vue"
export default component.exports